import React, { useState, useEffect } from 'react';
import { useHistory } from 'react-router-dom';
import { fetchData, postData, updateData } from '../../../apiService';
import { useAuth } from '../../../AuthContext';
import { tokenIsExpired } from '../../../authUtils';
import { FaEdit } from "react-icons/fa"; // or any edit icon

const AttendancePage = (props) => {
    const history = useHistory();
    const { isAuthenticated, companyId, userId, logout, token } = useAuth();

    const [staffData, setStaffData] = useState([]);
    const [attendanceSheet, setAttendanceSheet] = useState([]);
    const [selectedStatus, setSelectedStatus] = useState('');
    const [statusOptions, setstatusOptions] = useState([]);

    const today = new Date();
    const todayDate = today.toLocaleDateString('en-GB');
    const todayDayName = today.toLocaleDateString('en-US', { weekday: 'long' });

    const [selectedDate, setSelectedDate] = useState(todayDate); // initialize as needed

    const today1 = new Date();
    const todayDateISO = today.toISOString().split('T')[0]; // "2025-07-05"
    const todayDayName1 = today.toLocaleDateString('en-US', { weekday: 'long' });

    const [selectedDate1, setSelectedDate1] = useState(todayDateISO);

    useEffect(() => {
        if (isAuthenticated && tokenIsExpired(token)) {
            logout();
            return;
        }

        fetchAttendanceStatus();
        fetchStaff();
        fetchCurrentAttendance();

        if (selectedDate1) {
            fetchDatewiseAttendance();

            const day = new Date(selectedDate1).toLocaleDateString('en-US', { weekday: 'long' });
            setpreviousDayName(day);
        }
    }, [isAuthenticated, companyId, token, logout, selectedDate1]); // ✅ include selectedDate1 here


    const fetchStaff = async () => {
        try {
            const response = await fetchData('AttendanceSheetApi', `/StaffList/${companyId}`, token);
            if (response.responseCode === '1111') {
                setStaffData(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Staff:', error);
        }
    };

    const fetchAttendanceStatus = async () => {
        try {
            const response = await fetchData('AttendanceSheetApi', `/AttendanceStatusList/${companyId}`, token);
            if (response.responseCode === '1111') {
                const options = response.response_data.map(status => ({
                    value: status.Id,
                    label: status.Name,
                }));
                setstatusOptions(options);
            }
        } catch (error) {
            console.error('Error fetching Attendance Status:', error);
        }
    };

    const handleAttendanceChange = (staffId, selectedStatusId) => {
        const selectedStatus = statusOptions.find(opt => opt.value === selectedStatusId);
        setStaffData(prev =>
            prev.map(staff =>
                staff.id === staffId
                    ? {
                        ...staff,
                        attendanceStatusId: selectedStatusId,
                        attendanceStatusName: selectedStatus.label,
                        attendanceDate: todayDate,
                    }
                    : staff
            )
        );
    };

    const handleSubmitAttendance = async () => {
        const attendanceList = staffData
            .filter(s => s.attendanceStatusId)
            .map(s => ({
                Id: 0,
                StaffId: s.id,
                AttendanceStatusId: s.attendanceStatusId,
                StaffName: `${s.firstName} ${s.lastName}`,
                Designation: "Engineer",
                DayName: todayDayName,
                AttendanceStatusName: s.attendanceStatusName,
                AttendanceDate: new Date().toISOString().split('T')[0], // ✅ or use full ISO string if backend needs it
                IsActive: true,
                CreatedBy: userId,
                CreatedDate: new Date().toISOString(),
                CompanyId: companyId,
            }));

        const attendanceSheet = {
            AttendanceSheet: attendanceList, // ✅ Capitalized key
        };

        try {
            const response = await postData('AttendanceSheetApi', attendanceSheet, token);
            window.location.reload();
            if (response.responseCode === '1111') {
                alert('Attendance submitted successfully!');
                window.location.reload();
            } else {
                alert('Attendance submitted successfully.');
            }
        } catch (error) {
            console.error('Error submitting attendance:', error);
        }
    };

    const fetchCurrentAttendance = async () => {
        try {
            const response = await fetchData('AttendanceSheetApi', `/AttendanceDateWiseList/${companyId}`, token);
            if (response.responseCode === '1111') {
                setAttendanceSheet(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Attendace Sheet:', error);
        }
    };

    // Attendance Edit
    const [isEditMode, setIsEditMode] = useState(false);
    const [StatusOptions, setStatusOptions] = useState([
        { label: "Present", value: 1 },
        { label: "Absent", value: 2 },
        { label: "Half-Day", value: 3 },
        { label: "Holiday", value: 4 },
    ]);

    const handleAttendanceEditChange = async (staffId, statusId) => {
        const updatedSheet = attendanceSheet.map((staff) =>
            staff.id === staffId ? { ...staff, attendanceStatusId: statusId } : staff
        );
        setAttendanceSheet(updatedSheet);

        const updatedStaff = updatedSheet.find(s => s.id === staffId);

        const updatedData = {
            Id: updatedStaff.id,
            CompanyId: updatedStaff.companyId,
            StaffId: updatedStaff.staffId,
            AttendanceStatusId: statusId,
            StaffName: updatedStaff.staffName,
            Designation: updatedStaff.designation,
            DayName: updatedStaff.dayName,
            AttendanceStatusName: statusOptions.find(opt => opt.value === statusId)?.label || '',
            AttendanceDate: updatedStaff.attendanceDate,
            IsActive: true,
            CreatedBy: updatedStaff.createdBy,
            CreatedDate: updatedStaff.createdDate,
            ModifiedBy: userId, // assuming you have userId from login
            ModifiedDate: new Date().toISOString()
        };

        try {
            await updateData('AttendanceSheetApi', `${updatedStaff.id}`, updatedData, token);
            alert('Attendance updated successfully');
        } catch (error) {
            console.error('Error updating attendance:', error);
            alert('Failed to update attendance');
        }
    };



    const handleAttendancePreviousEditChange = async (staffId, statusId) => {
        const updatedSheet = previousattendanceSheet.map((staff) =>
            staff.Id === staffId ? { ...staff, AttendanceStatusId: statusId } : staff
        );
        setpreviousattendanceSheet(updatedSheet);

        const updatedStaff = updatedSheet.find(s => s.Id === staffId);

        const updatedData = {
            Id: updatedStaff.Id,
            CompanyId: updatedStaff.CompanyId,
            StaffId: updatedStaff.StaffId,
            AttendanceStatusId: statusId,
            StaffName: updatedStaff.StaffName,
            Designation: updatedStaff.Designation,
            DayName: updatedStaff.DayName,
            AttendanceStatusName: statusOptions.find(opt => opt.value === statusId)?.label || '',
            AttendanceDate: updatedStaff.AttendanceDate,
            IsActive: true,
            CreatedBy: updatedStaff.CreatedBy,
            CreatedDate: updatedStaff.CreatedDate,
            ModifiedBy: userId,
            ModifiedDate: new Date().toISOString()
        };

        try {
            await updateData('AttendanceSheetApi', `${updatedStaff.Id}`, updatedData, token);
            // Optional: Replace alert with toast or inline message
            alert('Attendance updated successfully');
        } catch (error) {
            console.error('Error updating attendance:', error);
            alert('Failed to update attendance');
        }
    };


    const closeEditMode = () => {
        setIsEditMode(false);
        fetchCurrentAttendance(); // Refresh the attendance sheet after closing edit mode
        fetchDatewiseAttendance();
    };

    // Date Wise Attendance Sheet
    const [isPreviousMode, setIsPreviousMode] = useState(false);

    const [previousattendanceSheet, setpreviousattendanceSheet] = useState([]);
    const [previousDayName, setpreviousDayName] = useState('');

    const fetchDatewiseAttendance = async () => {
        try {
            const response = await fetchData('AttendanceSheetApi', `/AttendanceDateWiseList/${companyId}/${selectedDate1}`, token);
            if (response.responseCode === '1111') {
                setpreviousattendanceSheet(response.response_data);
            }
        } catch (error) {
            console.error('Error fetching Attendace Sheet:', error);
        }
    };

    useEffect(() => {
        if (selectedDate1) {
            fetchDatewiseAttendance();

            const day = new Date(selectedDate1).toLocaleDateString('en-US', { weekday: 'long' });
            setpreviousDayName(day);
        }
    }, [selectedDate1]);


    const closePreviousMode = () => {
        setIsPreviousMode(false);
        fetchDatewiseAttendance(); // Refresh the attendance sheet after closing edit mode
    };

    const handleSubmitPreviousAttendance = async () => {
        const attendanceList = staffData
            .filter(s => s.attendanceStatusId)
            .map(s => ({
                Id: 0,
                StaffId: s.id,
                AttendanceStatusId: s.attendanceStatusId,
                StaffName: `${s.firstName} ${s.lastName}`,
                Designation: "Engineer",
                DayName: previousDayName,
                AttendanceStatusName: s.attendanceStatusName,
                AttendanceDate: selectedDate1, // ✅ or use full ISO string if backend needs it
                IsActive: true,
                CreatedBy: userId,
                CreatedDate: new Date().toISOString(),
                CompanyId: companyId,
            }));

        const attendanceSheet = {
            AttendanceSheet: attendanceList, // ✅ Capitalized key
        };

        try {
            const response = await postData('AttendanceSheetApi', attendanceSheet, token);
            window.location.reload();
            if (response.responseCode === '1111') {
                alert('Attendance submitted successfully!');
                window.location.reload();
            } else {
                alert('Attendance submitted successfully.');
            }
        } catch (error) {
            console.error('Error submitting attendance:', error);
        }
    };



    return (

        <div className="min-h-screen bg-gray-100 py-10 px-4">

            {/* ✅ Editable Table with Dropdowns */}

            {isEditMode && (
                <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg p-6 mt-10" style={{ marginTop: '-5px', height: '450px', overflowY: 'auto' }}>
                    <div className="flex justify-between mb-4">
                        <h6 className="font-semibold text-indigo-600 uppercase">Edit Attendance</h6>
                        <p className="text-center text-sm text-gray-600 mb-6">
                            Mark Attendance for <span className="font-semibold text-red-700">
                                {new Date(previousattendanceSheet[0].AttendanceDate).toLocaleDateString('en-IN', {
                                    day: '2-digit',
                                    month: 'short',
                                    year: 'numeric'
                                })} ({previousattendanceSheet[0].DayName})
                            </span>
                        </p>
                        <button onClick={() => closeEditMode()} title="Cancel Edit"
                            className="text-sm text-gray-500 hover:underline">
                            Cancel
                        </button>

                    </div>
                    <div className="overflow-x-auto rounded-xl border border-gray-200" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        <table className="min-w-full table-auto text-sm">
                            <thead className="bg-indigo-100 text-gray-700 text-left sticky top-0">
                                <tr>
                                    <th style={{ fontWeight: 'bold', padding: '5px', textTransform: 'uppercase' }}>Staff Name</th>
                                    {/* <th style={{ fontWeight: 'bold', padding: '5px', textTransform: 'uppercase' }}>Designation</th>
                                    <th style={{ fontWeight: 'bold', padding: '5px', textTransform: 'uppercase' }}>Day</th> */}
                                    <th style={{ fontWeight: 'bold', padding: '5px', textTransform: 'uppercase' }}>Attendance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {previousattendanceSheet.map((staff) => (
                                    <tr key={staff.id} className="border-b hover:bg-gray-50">
                                        <td style={{ fontWeight: 'bold', padding: '5px' }}>{staff.StaffName}</td>
                                        {/* <td style={{ fontWeight: 'bold', padding: '5px' }}>{staff.Designation}</td> */}
                                        {/* <td style={{ fontWeight: 'bold', padding: '5px' }}>{staff.DayName}</td> */}
                                        <td style={{ fontWeight: 'bold', padding: '5px' }}>
                                            <select
                                                value={staff.AttendanceStatusId || ''}
                                                onChange={(e) => handleAttendancePreviousEditChange(staff.Id, parseInt(e.target.value))}
                                                className="w-full rounded-md border border-gray-300 px-3 py-2 bg-white shadow-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none"
                                                style={{
                                                    color:
                                                        staff.AttendanceStatusId === 1 ? 'green' :
                                                            staff.AttendanceStatusId === 2 ? 'red' :
                                                                staff.AttendanceStatusId === 3 ? 'darkgoldenrod' :
                                                                    staff.AttendanceStatusId === 4 ? 'brown' :
                                                                        staff.attendanceStatusId === 5 ? 'orange' :
                                                                            staff.attendanceStatusId === 6 ? '#8A0000' :
                                                                                'black'
                                                }}
                                            >
                                                <option value="">Select</option>
                                                {StatusOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                </div>
            )}

            {!isEditMode && attendanceSheet && attendanceSheet.length > 0 && selectedDate1 === todayDate ? (
                // ✅ 1. Show today's attendance with date picker
                <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg p-6 mt-10" style={{ marginTop: '-5px', height: '450px', overflowY: 'auto' }}>
                    <div className="relative flex justify-center items-center mb-4">
                        <h6 className="font-semibold text-indigo-600 uppercase text-center w-full">
                            Attendance Summary
                        </h6>
                        <div className="absolute right-0 flex items-center gap-3">
                            <input
                                type="date"
                                value={selectedDate1}
                                onChange={(e) => setSelectedDate1(e.target.value)}
                                className="border border-gray-300 rounded px-2 py-1 text-sm"
                            />
                            <button onClick={() => setIsEditMode(true)} title="Edit">
                                <FaEdit className="text-indigo-600 hover:text-indigo-800 text-lg" />
                            </button>
                        </div>
                    </div>

                    <p className="text-center text-sm text-gray-600 mb-6">
                        For <span className="font-semibold text-red-700">{todayDate}</span>
                    </p>

                    <div className="overflow-x-auto rounded-xl border border-gray-200" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        <table className="min-w-full table-auto text-sm">
                            <thead className="bg-indigo-100 text-gray-700 text-left sticky top-0">
                                <tr>
                                    <th style={{ fontWeight: 'bold', textTransform: 'uppercase', padding: '5px' }}>Staff Name</th>
                                    {/* <th style={{ fontWeight: 'bold', textTransform: 'uppercase', padding: '5px' }}>Designation</th>*/}
                                    <th style={{ fontWeight: 'bold', textTransform: 'uppercase', padding: '5px' }}>Day</th>
                                    <th style={{ fontWeight: 'bold', textTransform: 'uppercase', padding: '5px' }}>Attendance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {attendanceSheet.map((sheet) => (
                                    <tr key={sheet.id} className="border-b hover:bg-gray-50">
                                        <td style={{ fontWeight: 'bold', padding: '5px' }}>{sheet.staffName}</td>
                                        {/* <td style={{ fontWeight: 'bold', padding: '5px' }}>{sheet.designation}</td> */}
                                        <td style={{ fontWeight: 'bold', padding: '5px' }}>{sheet.dayName}</td>
                                        <td
                                            style={{
                                                fontWeight: 'bold',
                                                padding: '5px',
                                                color:
                                                    sheet.attendanceStatusName === "Present" ? "green" :
                                                        sheet.attendanceStatusName === "Leave" ? "red" :
                                                            sheet.attendanceStatusName === "Holiday" ? "brown" :
                                                                sheet.attendanceStatusName === "Half-day" ? "darkgoldenrod" :
                                                                    sheet.attendanceStatusName === "Half-day LOP" ? "orange" :
                                                                        sheet.attendanceStatusName === "LOP" ? "#8A0000" :
                                                                            "black"
                                            }}
                                        >
                                            {sheet.attendanceStatusName}
                                        </td>

                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : !isEditMode && previousattendanceSheet && previousattendanceSheet.length > 0 ? (
                // ✅ 2. Show previous date data
                <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg p-6 mt-10" style={{ marginTop: '-5px', height: '450px', overflowY: 'auto' }}>
                    <div className="relative flex justify-center items-center mb-4">
                        <h6 className="font-semibold text-indigo-600 uppercase text-center w-full">
                            {(selectedDate1 === todayDate && attendanceSheet && attendanceSheet.length > 0)
                                ? 'Attendance Summary'
                                : 'Attendance Summary'}
                        </h6>
                        <div className="absolute right-0 flex items-center gap-3">
                            <input
                                type="date"
                                value={selectedDate1}
                                onChange={(e) => setSelectedDate1(e.target.value)}
                                className="border border-gray-300 rounded px-2 py-1 text-sm"
                            />
                            <button onClick={() => setIsEditMode(true)} title="Edit">
                                <FaEdit className="text-indigo-600 hover:text-indigo-800 text-lg" />
                            </button>
                        </div>
                    </div>

                    <p className="text-center text-sm text-gray-600 mb-6">
                        For <span className="font-semibold text-red-700">{selectedDate1} ({previousattendanceSheet[0].DayName})</span>
                    </p>

                    <div className="overflow-x-auto rounded-xl border border-gray-200" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        <table className="min-w-full table-auto text-sm">
                            <thead className="bg-indigo-100 text-gray-700 text-left sticky top-0">
                                <tr>
                                    <th style={{ fontWeight: 'bold', textTransform: 'uppercase', padding: '5px' }}>Staff Name</th>
                                    {/* <th style={{ fontWeight: 'bold', textTransform: 'uppercase', padding: '5px' }}>Designation</th>
                                    <th style={{ fontWeight: 'bold', textTransform: 'uppercase', padding: '5px' }}>Day</th> */}
                                    <th style={{ fontWeight: 'bold', textTransform: 'uppercase', padding: '5px' }}>Attendance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {previousattendanceSheet.map((sheet) => (
                                    <tr key={sheet.id} className="border-b hover:bg-gray-50">
                                        <td style={{ fontWeight: 'bold', padding: '5px' }}>{sheet.StaffName}</td>
                                        {/* <td style={{ fontWeight: 'bold', padding: '5px' }}>{sheet.Designation}</td>
                                        <td style={{ fontWeight: 'bold', padding: '5px' }}>{sheet.DayName}</td> */}
                                        <td
                                            className="font-bold p-2"
                                            style={{
                                                fontWeight: 'bold',
                                                padding: '5px',
                                                color:
                                                    sheet.AttendanceStatusName === "Present" ? "green" :
                                                        sheet.AttendanceStatusName === "Leave" ? "red" :
                                                            sheet.AttendanceStatusName === "Holiday" ? "brown" :
                                                                sheet.AttendanceStatusName === "Half-day" ? "darkgoldenrod" :
                                                                    sheet.attendanceStatusName === "Half-day LOP" ? "orange" :
                                                                        sheet.attendanceStatusName === "LOP" ? "#8A0000" :
                                                                            "black"
                                            }}
                                        >
                                            {sheet.AttendanceStatusName}
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                </div>
            ) : !isEditMode && (
                // ✅ 3. Entry form when no data at all
                <div className="max-w-6xl mx-auto bg-white rounded-2xl shadow-lg p-6 mt-10" style={{ marginTop: '-5px', height: '450px', overflowY: 'auto' }}>
                    <h6 className="font-semibold mb-4 text-center text-indigo-600 uppercase">
                        Staff Attendance
                    </h6>
                    <div className="relative flex justify-center items-center mb-4">
                        <div className="absolute right-0 flex items-center gap-3">
                            <input
                                type="date"
                                value={selectedDate1}
                                onChange={(e) => setSelectedDate1(e.target.value)}
                                className="border border-gray-300 rounded px-2 py-1 text-sm"
                            />
                            <button onClick={() => setIsEditMode(true)} title="Edit">
                                <FaEdit className="text-indigo-600 hover:text-indigo-800 text-lg" />
                            </button>
                        </div>
                    </div>
                    <p className="text-center text-sm text-gray-600 mb-6">
                        Mark Attendance for <span className="font-semibold text-red-700">{selectedDate1} ({previousDayName})</span>
                    </p>

                    <div className="overflow-x-auto rounded-xl border border-gray-200" style={{ maxHeight: '400px', overflowY: 'auto' }}>
                        <table className="min-w-full table-auto text-sm">
                            <thead className="bg-indigo-100 text-gray-700 text-left sticky top-0">
                                <tr>
                                    <th style={{ fontWeight: 'bold', textTransform: 'uppercase', padding: '5px' }}>Staff Name</th>
                                    {/* <th style={{ fontWeight: 'bold', textTransform: 'uppercase', padding: '5px' }}>Designation</th>*/}
                                    <th style={{ fontWeight: 'bold', textTransform: 'uppercase', padding: '5px' }}>Attendance</th>
                                </tr>
                            </thead>
                            <tbody>
                                {staffData.map((staff) => (
                                    <tr key={staff.id} className="border-b hover:bg-gray-50">
                                        <td style={{ fontWeight: 'bold', padding: '5px' }}>{staff.firstName} {staff.lastName}</td>
                                        {/* <td style={{ fontWeight: 'bold', padding: '5px' }}>Engineer</td> */}
                                        <td style={{ fontWeight: 'bold', padding: '5px' }}>
                                            <select
                                                value={staff.attendanceStatusId || ''}
                                                onChange={(e) => handleAttendanceChange(staff.id, parseInt(e.target.value))}
                                                className="w-full rounded-md border border-gray-300 px-3 py-2 bg-white shadow-sm focus:ring-2 focus:ring-indigo-400 focus:outline-none"
                                                style={{
                                                    color:
                                                        staff.attendanceStatusId === 1 ? 'green' :
                                                            staff.attendanceStatusId === 2 ? 'red' :
                                                                staff.attendanceStatusId === 3 ? 'darkgoldenrod' :
                                                                    staff.attendanceStatusId === 4 ? 'brown' :
                                                                        staff.attendanceStatusId === 5 ? 'orange' :
                                                                            staff.attendanceStatusId === 6 ? '#8A0000' :
                                                                                'black',
                                                }}
                                            >
                                                <option value="">Select</option>
                                                {statusOptions.map((option) => (
                                                    <option key={option.value} value={option.value}>
                                                        {option.label}
                                                    </option>
                                                ))}
                                            </select>
                                        </td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>

                    <div className="mt-6 text-center">
                        <button
                            onClick={handleSubmitPreviousAttendance}
                            className="bg-indigo-600 text-white px-6 py-2 rounded-md shadow-md hover:bg-indigo-700 transition"
                        >
                            Submit Attendance
                        </button>
                    </div>
                </div>
            )}


        </div>

    );
};

export default AttendancePage;
